export const CLAIMS_PAGE_PERIOD_QUERY_KEY = "period";
export const CLAIMS_PAGE_CLAIM_NUMBER_QUERY_KEY = "claim-number";
export const CLAIMS_PAGE_SELECTED_QUERY_KEY = "selected";
export const CLAIMS_PAGE_SEARCH_QUERY_KEY = "search";
export const CLAIMS_PAGE_STATUS_QUERY_KEY = "status";
export const CLAIMS_PAGE_REASON_QUERY_KEY = "reason";
export const CLAIMS_PAGE_CREATE_PERIOD_QUERY_KEY = "created";
export const CLAIMS_PAGE_SELECTED_DETAIL_TAB_QUERY_KEY = "selected-detail-tab";
